// base styles
import borders from "assets/mavric-theme/base/borders";
import colors from "assets/mavric-theme/base/colors";
import typography from "assets/mavric-theme/base/typography";

// helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { borderWidth } = borders;
const { light, primary } = colors;
const { size } = typography;

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(0.2)} ${pxToRem(0.2)}`,
      //borderBottom: `${borderWidth[1]} solid ${light.main}`,
      fontSize: size.xs,
      color: primary.focus,
    },
  },
};

export default tableCell;
